import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import AnalyticsDashboard from "./analyticsDashboard";
import Participation from "./fullGraphs/participation";
import Leaderboard from "./fullGraphs/leaderboard";
import Organization from "./fullGraphs/organization";
import Bonuses from "./fullGraphs/bonuses";
import TopWords from "./fullGraphs/top_words";

export interface AnalyticsRouterProps {
  fetchParticipationData: any;
  fetchOrganizationData: any;
  fetchLeaderboardData: any;
  fetchBonusesData: any;
  fetchTopWordsData: any;
  devMode: boolean;
  teamId: string;
  teamName: string;
  managerBasedTeam: boolean;
  participation: any;
  leaderboard: any;
  organization: any;
  bonuses: any;
  topWords: any;
  hideCompetitiveFeatures: boolean;
  children?: React.ReactNode;
  showSuperBanner: boolean;
  showPersistentBanner: boolean;
}

export default class AnalyticsRouter extends React.Component<
  Partial<AnalyticsRouterProps>,
  any
> {
  render() {
    return (
      <div className="brand-color-top-background-container has-brand-bg analytics-dash-brand-color">
        <div className="analytics-container-v2">
          <Router>
            <Switch>
              {this.renderGatedRoute(
                "/analytics/dashboard/participation",
                Participation
              )}
              {this.renderGatedRoute(
                "/analytics/dashboard/leaderboard",
                Leaderboard
              )}
              {this.renderGatedRoute(
                "/analytics/dashboard/organization",
                Organization
              )}
              {this.renderGatedRoute("/analytics/dashboard/bonuses", Bonuses)}
              {this.renderGatedRoute(
                "/analytics/dashboard/top_words",
                TopWords
              )}
              {this.renderDashboardRoute()}
            </Switch>
          </Router>
        </div>
      </div>
    );
  }

  renderDashboardRoute = () => {
    return (
      <Route
        path="/analytics/dashboard"
        render={() => {
          return <AnalyticsDashboard {...this.props} />;
        }}
      />
    );
  };

  renderGatedRoute = (path, Component) => {
    if (this.props.devMode) {
      return (
        <Route
          path={path}
          exact
          render={() => {
            return <Component {...this.props} />;
          }}
        />
      );
    }

    return this.renderDashboardRoute();
  };
}
